export const formAfterSubmit = () => {
  const triggerContactFormSend = () => {
    const headerWrapper = document.querySelector('.js-header-menu') as HTMLFormElement
    const headerSummoner = document.querySelector('.js-menu-summonButton') as HTMLFormElement

    const headerImageWrapper = document.querySelector('.js-header-imageWrapper') as HTMLFormElement

    const allInputElements = document.querySelectorAll('.js-contactForm-inputWrapper label') as unknown as NodeListOf<HTMLLabelElement>

    const headerMessageContainer = document.querySelector('.js-header-imageWrapperNewsletterThankYou') as HTMLFormElement

    if (!headerWrapper.classList.contains('-isOpened')) {
      headerSummoner.click()
    }

    headerImageWrapper.classList.add('-sent')

    headerMessageContainer.innerHTML = 'Děkujeme za zprávu.<br>Brzy se vám ozveme.<br>Co vás ještě zajímá?'

    setTimeout(() => {
      headerImageWrapper.classList.add('-stretched')
    }, 300)

    setTimeout(() => {
      allInputElements.forEach((inputElement) => {
        inputElement.style.display = 'block'
      })
    }, 1000)
  }

  const wpcf7Elm = document.querySelector('.wpcf7')

  if (wpcf7Elm) {
    wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
      triggerContactFormSend()
    }, false)
  }
}
